
import { useMutation } from '@tanstack/react-query'
import {
    applyVoucher,
    postDownloadInvoice,
    postPaymentInvoice
} from "./api"

export const useApplyVoucher = () => {
    return useMutation({
        queryKey: ['apply-voucher'],
        mutationFn: ({ id, data }) => applyVoucher(id, data),
    })
}

export const usePostDownloadInvoice = () => {
    return useMutation({
        queryKey: ['post-download-invoice'],
        mutationFn: ({ params }) => postDownloadInvoice(params),
    })
}

export const usePostPaymentInvoice = () => {
    return useMutation({
        queryKey: ['post-payment-invoice'],
        mutationFn: ({ params }) => postPaymentInvoice(params),
    })
}